import {useEffect, useRef, useState} from "react";
import {productListImages, products} from "../data/data";
import {ProductSideMenu} from "./ProductSideMenu";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import icon_basket from "../assets/icon/ic_basket.svg";
import {MultiLineIndexText, NewlineText} from "./common/NewlineText";
import SectionDivider from "./common/SectionDivider";

export const ProductList = ({type, id, onPlaceOrder}) => {
    const [product, setProduct] = useState(products[0]);
    const [item, setItem] = useState(product.groups[0].items[0]);

    const {t} = useTranslation();
    const contentRef = useRef(null);

    useEffect(() => {
        const p = products.find((it) => it.type === type) || products[0]
        setProduct(p)

        let i
        for (const g of p.groups) {
            i = g.items.find((it) => `${it.id}` === id)
            if (i != null) {
                break
            }
        }

        i = i || p.groups[0].items[0]
        setItem(i)

    }, [type, id])

    const onProductChange = (product) => {
        setProduct(product);
        onItemChange(product.groups[0].items[0])
    }

    const onItemChange = (item) => {
        setItem(item)
        contentRef?.current.scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"})
    }

    return (
        <div className="flex flex-col">
            <img src={product.banner} className="aspect-3.5 object-cover" alt="Banner"/>
            <div ref={contentRef}></div>
            <ProductTab products={products} selectedProduct={product} onProductChange={onProductChange}/>
            <div className="flex flex-row gap-16 place-content-center py-12">
                <ProductSideMenu product={product} selectedItem={item} onChange={onItemChange}/>
                <div className="flex flex-col text-left w-3/6 max-md:w-full max-md:mx-8">
                    <p className="font-bold text-secondary-color text-3xl mb-8">{t(item.title)}</p>
                    <NewlineText className="text-base my-0.5" text={t(item.content)}/>
                    <button onClick={onPlaceOrder}
                            className="flex flex-row w-fit items-center justify-center mt-6
                                   bg-primary py-2 px-5 text-white gap-2 text-base font-bold">
                        <img src={icon_basket} alt="Basket icon"/>
                        <div>{t("basket_button_title")}</div>
                    </button>
                    <div className="h-8"/>
                    <img className="w-96 rounded-[20px]"
                        src={productListImages[`${product.type}_${item.id}`]} alt={`${item.title}`}/>
                    <div className="h-8"/>
                    <div className="text-xl font-bold mb-2">{t("product_feature_title")}</div>
                    <SectionDivider className="mb-6"/>
                    <MultiLineIndexText className="text-black m-0.5" text={t(item.feature)}/>
                    <div className="h-12"/>
                    {item.package != null &&
                        <ProductTable title={t(item.package.title)} size={item.package.items.length}>
                            {item.package.items.map((item, index) => (
                                <>
                                    <div key={`${index}-detail`} className={`table-item separate 
                                        ${index % 2 === 0 ? "bg-secondary-light" : "bg-yellow"}`}>{t(item.detail)}</div>
                                    <div key={`${index}-uint`} className={`table-item 
                                        ${index % 2 === 0 ? "bg-secondary-light" : "bg-yellow"}`}>{t(item.unit)}</div>
                                </>
                            ))}
                        </ProductTable>}
                </div>
            </div>
        </div>
    )
}

const ProductTab = ({products, selectedProduct, onProductChange}) => {
    const {t} = useTranslation();
    return (
        <div className="flex text-xl font-bold place-content-center pt-8">
            <ul className="flex gap-2 justify-center place-content-center border-b-2 border-gray">
                {products.map((product, index) => (
                    <li key={index} onClick={() => onProductChange(product)}>
                        <Link to={`/product/${product.type}`}>
                            <div className={`inline-block p-2 border-b-4 rounded-sm min-w-64
                                ${product.id === selectedProduct.id ?
                                "active border-primary text-primary" : "border-transparent text-grey"}`}>
                                {t(product.category)} </div>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    )
}

const ProductTable = (props) => {
    //TODO: Fix row-span to dynamically adjust by props.size
    const span = props.size === 1 ? "row-span-1" : "row-span-9";
    const { t } = useTranslation();
    return (
        <div key={props.key} className="product-table grid grid-cols-3 w-full mb-6">
            <div className="header col-span-3 justify-center text-center">{t('product_table_header_1')}</div>
            <div className="sub-header separate">{t('product_table_sub_header_1')}</div>
            <div className="sub-header separate">{t('product_table_sub_header_2')}</div>
            <div className="sub-header">{t('product_table_sub_header_3')}</div>
            <div className={`border-b border-gray-light bg-yellow/80 p-4 ${span}`}>
                <NewlineText className="text-sm" text={props.title}/>
            </div>
            {props.children}
        </div>
    )
}